const services = [
  {
    title: "Mechanical",
    icon: "/mechanical_outline.png",
    color: "grey",
    border: "border-gray-400",
  },
  {
    title: "Electrical",
    icon: "/electrical_outline.png",
    color: "orange",
    border: "border-orange-500",
  },
  {
    title: "Plumbing",
    icon: "/plumbing_outline.png",
    color: "blue",
    border: "border-blue-500",
  },
];

export default function Services() {
  return (
    <section className="relative -mt-12 md:-mt-16 z-20 px-4 md:px-10 lg:px-20 max-w-6xl mx-auto pb-16 pt-16 md:pt-0">
      
      {/* Always 3 cols from md and above */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-20 md:gap-6 lg:gap-8">
        
        {services.map((s) => (
          <div
            key={s.title}
            className="relative flex flex-col items-center 
              pt-16 md:pt-18 lg:pt-20 
              pb-6 md:pb-8 
              px-4 md:px-5 lg:px-6 
              bg-white rounded-2xl shadow-lg 
              hover:shadow-xl transition-all duration-300"
          >
            
            {/* Floating Icon Circle */}
            <div
              className={`absolute -top-14 md:-top-16 left-1/2 transform -translate-x-1/2 
              w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 
              rounded-full flex items-center justify-center 
              shadow-lg backdrop-blur-xl border-4 ${s.border}`}
            >
              <img
                src={s.icon}
                alt={s.title}
                className="w-16 h-16 md:w-18 md:h-18 lg:w-20 lg:h-20 object-contain drop-shadow-md"
              />
            </div>

            {/* Service Content */}
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 mt-4">
              {s.title}
            </h3>

            <p className="text-gray-500 text-sm font-light">
              Services
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
